import React, {useEffect} from 'react';
import {extractReverseGeocoding} from '../../services/maps';
import {useGoogleMaps} from './MapContext';

const MarkerTracker = ({onChange}) => {
    const map = useGoogleMaps();
    const marker = React.useMemo(() => new google.maps.Marker({
        draggable: true,
        position: {lat: 0, lng: 0},
    }), []);
    const updateCoordinates = React.useCallback(async (coords) => {
        const geocoder = new google.maps.Geocoder();
        const {results} = await geocoder.geocode({location: coords});
        const geocoding = extractReverseGeocoding(results) || {};
        onChange({...coords, ...geocoding});
    }, [onChange]);
    useEffect(() => {
        if (map && marker) {
            google.maps.event.addListener(map, 'click', function(e) {
                marker.setPosition(e.latLng);
                marker.setMap(map);
                updateCoordinates({lat: e.latLng.lat(), lng: e.latLng.lng()});
            });
            google.maps.event.addListener(marker, 'dragend', function() {
                updateCoordinates({lat: marker.getPosition().lat(), lng: marker.getPosition().lng()});
            });
        }
    }, [map, marker]);

    if (!map) {
        return null;
    }
    return null;
};

export default MarkerTracker;
